export enum BrandingHiddenSections {
    Integrations = 'integrations',
    Billing = 'billing',
    Files = 'files',
    Developers = 'developers',
    Upgrade = 'upgrade',
}